// Replace images on VDB search results page with better static images.
// The same static image will be shown for all diamonds of that shape.

$(document).ready(() => {
  // Check if this is the VDB Shopify App
  if (window.location.href.includes("apps/diamond-inventory")) {
    // Search results load asynchronously
    // Set tracking variable and check if results have loaded periodically
    window.vdbImagesUpdated = false;
    window.vdbLoadingTextUpdated = false;

    // Override back button and refresh
    window.addEventListener("popstate", function (e) {
      window.location.reload();
    });

    // Hide search results container until images are replaced so stock photos don't show
    const searchResultsContainer = $('.vdb-search-result-middle');
    searchResultsContainer.hide();

    const shapes = [];
    const imageUrls = {};

    // Build JS array of shapes and images using Liquid syntax for generating image URLs
    
    
      
      imageUrls['Round'] = '//edmarshall.com/cdn/shop/t/13/assets/Round.jpg?v=155886489174316750471789805781';
      shapes.push('Round');
    
      
      imageUrls['Oval'] = '//edmarshall.com/cdn/shop/t/13/assets/Oval.jpg?v=178815837677069394781789805783';
      shapes.push('Oval');
    
      
      imageUrls['Pear'] = '//edmarshall.com/cdn/shop/t/13/assets/Pear.jpg?v=21209294096547827261789805784';
      shapes.push('Pear');
    
      
      imageUrls['Emerald'] = '//edmarshall.com/cdn/shop/t/13/assets/Emerald.jpg?v=10058056349092081431789805781';
      shapes.push('Emerald');
    
      
      imageUrls['Princess'] = '//edmarshall.com/cdn/shop/t/13/assets/Princess.jpg?v=136175867775372486941789805784';
      shapes.push('Princess');
    
      
      imageUrls['Radiant'] = '//edmarshall.com/cdn/shop/t/13/assets/Radiant.jpg?v=164502091257617724501789805781';
      shapes.push('Radiant');
    
      
      imageUrls['Cushion'] = '//edmarshall.com/cdn/shop/t/13/assets/Cushion.jpg?v=119190771997636689811789805781';
      shapes.push('Cushion');
    
      
      imageUrls['Marquise'] = '//edmarshall.com/cdn/shop/t/13/assets/Marquise.jpg?v=23305471177425704071789805782';
      shapes.push('Marquise');
    
      
      imageUrls['Heart'] = '//edmarshall.com/cdn/shop/t/13/assets/Heart.jpg?v=53707096428503414481789805782';
      shapes.push('Heart');
    
      
      imageUrls['Trilliant'] = '//edmarshall.com/cdn/shop/t/13/assets/Trilliant.jpg?v=147046923643350875681789805782';
      shapes.push('Trilliant');
    

    const replaceShapeImages = (shape) => {
      const imageUrl = imageUrls[shape];
      

      const $productEls = $(`.vdb-product-name:contains(${shape}):not([data-image-updated])`);
      if ($productEls.length) {
        $productEls.each(function() {
          $(this).attr('data-image-updated', true);
          const imageContainer = $(this).closest('.vdb-search-result-block-bg');
          const imageEl = $(imageContainer).find('.vdb-search-result-image img');
          
          $(imageEl).unbind('onerror');
          $(imageEl).attr('src', imageUrl);

          $('.vdb-vi.vdb-icon_detail_page_image_white').attr('src', imageUrl);

          $(this).attr('rel', 'loaded');
        });
      }
    };

    const replaceImages = () => {
      shapes.forEach(replaceShapeImages);
    };

    const updateLoadingText = () => {
      $('#main_page_cover > div > span').text('Searching diamonds…');
    };

    const tryImageUpdates = () => {
      setTimeout(() => {
        const searchResultsLoaded = !!$(".vdb-search-result-image").length;
        if (searchResultsLoaded) {
          replaceImages();
          window.vdbImagesUpdated = true;
          // show container that was hidden until images were loaded
          // delay to allow time for images to load
          setTimeout(() => {
            searchResultsContainer.show(); 
          }, 250);
        } else {
          console.log("try")
          tryImageUpdates();
        }
      }, 250);
    };

    const tryLoadingTextUpdates = () => {
      setTimeout(() => {
        if (!window.vdbLoadingTextUpdated) {
          updateLoadingText();
          
          window.vdbLoadingTextUpdated = true;
        } else {
          tryLoadingTextUpdates();
        }
      }, 100);
    };

    tryImageUpdates();
    tryLoadingTextUpdates();
    
    $('body').on('DOMNodeInserted', '.vdb-parent-grid', replaceImages);

    // The actual image for the product detail page is inserted separately from this ".vbd-short-title" node
    $('body').on('DOMNodeInserted', '.vdb-only-mobile .vdb-short-title', function () {
      const shape = shapes.find((shape) => {
        const $matchingTitleEl = $(`.vdb-short-title:contains(${shape})`);
        return !!$matchingTitleEl.length
      });
      const imageUrl = imageUrls[shape];
      const imageThumbnailsContainer = $(this).closest('.vdb-align-start');

      // There's a delay after the product detail page is loaded and when the image is added
      setTimeout(() => {
        const productDetailImage = $(imageThumbnailsContainer).find('.vdb-icon_detail_page_image_white');
  
        if ($(productDetailImage).length) {
          $(productDetailImage).unbind('onerror');
          $(productDetailImage).attr('src', imageUrl);
        }
      }, 100);
    });
  }
});